import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleExclamation, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-toast-error',
  standalone: true,
  template: `
    <div *transloco="let t" class="d-flex align-items-center">
      <fa-icon [icon]="faCircleExclamation" class="me-2"></fa-icon>
      <span>{{ t(message()) }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent, TranslocoDirective],
})
export class ToastErrorComponent {
  readonly faCircleExclamation: IconDefinition = faCircleExclamation;
  readonly message = input<string>('');
}
